import { render, staticRenderFns } from "./UsersAndTeams.vue?vue&type=template&id=68cc5044&scoped=true"
import script from "./UsersAndTeams.vue?vue&type=script&lang=js"
export * from "./UsersAndTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cc5044",
  null
  
)

export default component.exports